// data is a CSV export of:
// https://docs.google.com/spreadsheets/d/1N-O1Y9CHJ1VOk-cWTbhasGySsKK31KVr4UGpfCwz3mI/edit?gid=0#gid=0
export default `
District,Senator,SB79 Vote,Party
1,Megan Dahle,Yes,R
2,Mike McGuire,Yes,D
3,Christopher L. Cabaldon,Yes,D
4,Marie Alvarado-Gil,NVR,R
5,Gerald 'Jerry' McNerney,Yes,D
6,Roger Niello,NVR,R
7,Jesse Arreguin,Yes,D
8,Angelique Ashby,Yes,D
9,Tim Grayson,Yes,D
10,Aisha Wahab,Yes,D
11,Scott Wiener,Yes,D
12,Shannon L. Grove,Yes,R
13,Josh Becker,NVR,D
14,Anna M. Caballero,Yes,D
15,Dave Cortese,Yes,D
16,Melissa Hurtado,Yes,D
17,John S. Laird,Yes,D
18,Stephen C. Padilla,Yes,D
19,Rosilicie Ochoa Bogh,Yes,R
20,Caroline Menjivar,No,D
21,Monique Limón,NVR,D
22,Susan Rubio,NVR,D
23,Suzette Martinez Valladares,No,R
24,Benjamin 'Ben' Allen,NVR,D
25,Sasha Renée Pérez,Yes,D
26,Maria Elena Durazo,Yes,D
27,Henry Stern,No,D
28,Lola Smallwood-Cuevas,NVR,D
29,Eloise Gomez Reyes,Yes,D
30,Bob J. Archuleta,NVR,D
31,Sabrina Cervantes,Yes,D
32,Kelly Seyarto,No,R
33,Lena Gonzalez,NVR,D
34,Thomas 'Tom' Umberg,Yes,D
35,Laura Richardson,No,D
36,Tony Strickland,No,R
37,Steven S. 'Steve' Choi,NVR,R
38,Catherine S. Blakespear,No,D
39,Akilah Weber,NVR,D
40,Brian W. Jones,No,R
`
